import React, { Fragment, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/LoaderSpinner";
import FileUpload from "../../common/FileUpload";
import {
  getAllRegistrations,
  updateStudentRestriction,
  getRegistrationsByFilter,
  setFetchSuccess
} from "../../api/admissionApi";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { uploadSingleFileToS3 } from "../../api/fileUploadApi";
import moment from "moment";

const defaultValues = {
  formNo: '',
  admissionStatus: 'none'
};

export default function AuthStudentLogin() {
  const [filters, setFilters] = useState(defaultValues);
  const [showFilters, toggleFilters] = useState(true);
  const [isFilterSelected, setFilterSelected] = useState(false);

  const dispatch = useDispatch();
  const getAllStudentRegistrations = (ecb) => dispatch(getAllRegistrations(ecb));
  const updateLoginRestrict = (data, cbs) => dispatch(updateStudentRestriction(data, cbs));
  const state = useSelector(state => state);
  const { admissionReducer: { fetchingReg, filteredReg = [], admissionPageInfo = {}, isFetchingExistingAdmsnPageInfo, fetchRegSuccess } = {},
    authenticationReducer: {
      studentProfile: { is_registration_completed, email_id, formNumber },
      isStudent, faculty_id
    } = {}
  } = state || {};

  const fetchAllRegistrations = () => {
    resetFilters();
    getAllStudentRegistrations(errorCallback);
  }
  const errorCallback = (err) => {
    if (err.data.registrations === "No registrations found with provided filters") toast.error(err.data.registrations, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
    else
      toast.error("Invalid filters passed!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
  }

  const blockUserHandler = (reg) => {
    const requestParam = {
      emailId: reg.email_id,
      updatedBy: faculty_id,
      action: "block"
    };
    const callbacks = {
      successCallback: loginActionSuccessCallback,
      failureCallback: loginActionFailureCallback
    }
    updateLoginRestrict(requestParam, callbacks);
  };
  const unblockUserHandler = (reg) => {
    const requestParam = {
      emailId: reg.email_id,
      updatedBy: faculty_id,
      action: "unblock"
    };
    console.log("unblock payload: ", requestParam);
    const callbacks = {
      successCallback: loginActionSuccessCallback,
      failureCallback: loginActionFailureCallback
    }
    updateLoginRestrict(requestParam, callbacks);
  }

  const loginActionSuccessCallback = (resp) => {
    if (resp.status) {
      toast.success(resp.message);
      fetchAllRegistrations();
    }
    else loginActionFailureCallback(resp);
  }
  const loginActionFailureCallback = (errData) => {
    if (errData.message) toast.error(errData.message);
  }

  const renderCompleteList = () => {
    if (!filteredReg.length) return null;
    return (
      <div className="table-responsive card">
        <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
          <thead>
            <tr>
              <th style={{ borderRight: "1px solid #eee" }}>Form No.</th>
              <th style={{ borderRight: "1px solid #eee" }}>Name</th>
              <th style={{ borderRight: "1px solid #eee" }}>Email Id</th>
              <th style={{ borderRight: "1px solid #eee" }}>Phone</th>
              <th style={{ borderRight: "1px solid #eee" }}>Block/Un-Block</th>
              <th style={{ borderRight: "1px solid #eee" }}>Last updated on</th>
              <th style={{ borderRight: "1px solid #eee" }}>Last updated by</th>
            </tr>
          </thead>
          <tbody>
            {filteredReg.map((reg = {}, idx) => {
              const { login_restricted = false, login_restriction_updated_on = "", login_restriction_updated_by = "", full_name: { first_name = '', last_name = '' } = {} } = reg;
              return (
                <tr key={idx}>
                  <td style={{ textAlign: "center", borderRight: "1px solid #eee" }}>{reg.formNumber ? reg.formNumber : '-'}</td>
                  <td style={{ borderRight: "1px solid #eee" }}><span className="font-16">{`${first_name} ${last_name}`}</span></td>
                  <td style={{ borderRight: "1px solid #eee" }}>{reg.email_id}</td>
                  <td style={{ borderRight: "1px solid #eee", textAlign: "center", borderRight: "1px solid #eee" }}>{reg.mobile_number}</td>
                  <td style={{ borderRight: "1px solid #eee", textAlign: "center" }}>
                    <button type="button" className={`btn mr-10 ${login_restricted ? `btn-danger disabled` : `btn-outline-danger`}`} onClick={() => blockUserHandler(reg)}>{login_restricted ? `Blocked` : `Block`}</button>
                    <button type="button" className={`btn mr-10 ${login_restricted ? `btn-outline-primary` : `btn-primary disabled`}`} onClick={() => unblockUserHandler(reg)}>{login_restricted ? `Un-Block` : `Active`}</button>

                  </td>
                  <td style={{ borderRight: "1px solid #eee", textAlign: "center" }}>
                    {login_restriction_updated_on !== "" && <p>{moment(login_restriction_updated_on).format("DD-MMM-YY HH:MM")}</p>}
                  </td>
                  <td style={{ borderRight: "1px solid #eee", textAlign: "center" }}>
                    {login_restriction_updated_by !== "" && <p>{login_restriction_updated_by}</p>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const fetchRegistrationsByFilter = () => {
    const payload = {
      formNumber: filters.formNo === 'none' ? '' : filters.formNo,
      admissionStatus: filters.admissionStatus === 'none' ? '' : filters.admissionStatus
    };
    dispatch(getRegistrationsByFilter(payload, errorCallback));
  }

  const onChangeFilters = (filterName = '', value = '') => {
    let isChanged = false;
    const newFilters = { ...filters, [filterName]: value.trimStart() };
    Object.keys(defaultValues).forEach(key => {
      if (defaultValues[key] !== newFilters[key]) {
        isChanged = true;
        if (key === 'admissionStatus') {
          dispatch(setFetchSuccess(false));
        }
      }
    });

    setFilters(newFilters);
    setFilterSelected(isChanged);
  }

  const bulkAction = ({blockAll = false, unBlockAll = false}) => {
    if (blockAll) {
      console.log('Blocked all');
    }

    if (unBlockAll) {
      console.log('unblocked all');
    }
  }

  const resetFilters = () => {
    setFilters(defaultValues);
    setFilterSelected(false);
  }

  const renderFilterSection = () => {

    let selectedFilters = '';

    Object.keys(filters).forEach(key => {
      if (filters[key] !== defaultValues[key]) {
        selectedFilters = selectedFilters + key + ': ' + filters[key] + '; ';
      }
    })

    return (
      <div className="accordion" id="accordionExample">
        <div className="card" style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}>
          <div className="card-header p-0" id="headingOne">
            <h2 className="mb-0 d-flex align-items-center" style={{ width: "100%" }}>
              <button className="btn btn-block text-left btn-focus" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={() => toggleFilters(!showFilters)}>
                <h4 className="text-line pl-1">Filters</h4>
              </button>
              {showFilters ?
                <i className="fa fa-angle-up text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i> :
                <i className="fa fa-angle-down text-arrow pr-3 mb-1" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => toggleFilters(!showFilters)}></i>
              }
            </h2>
          </div>
          <div id="collapseOne" className={`collapse ${showFilters ? 'show' : ''}`} aria-labelledby="headingOne" data-parent="#accordionExample">
            <div className="card-body pt-0 pb-2">
              <div className="d-flex justify-content-between mb-3">
                <h6 className="mb-0">Filter By</h6>
                <div className="link" style={{ textDecoration: 'underline' }} onClick={resetFilters}>Reset Filters</div>
              </div>
              <div className="d-flex mb-4 align-items-center">
                Form/Registration Number:
                <input type="text" className="form-control w-25 ml-3" placeholder="Reg. no" value={filters['formNo']} onChange={(e) => onChangeFilters('formNo', e.target.value)} />
                <div className="d-flex align-items-center ml-5">
                  <FormControl sx={{ width: 150 }} size="small">
                    <InputLabel id="demo-simple-select-label">
                      Admission Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Admission Status"
                      value={filters['admissionStatus']}
                      onChange={(e) => onChangeFilters('admissionStatus', e.target.value)}
                    >
                      <MenuItem value="none">--Select--</MenuItem>
                      <MenuItem value="paidnverified">{`Paid & Verified`}</MenuItem>
                      <MenuItem value="unpaid">Unpaid</MenuItem>
                      <MenuItem value="unverified">Unverified</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="d-flex align-items-center mt-3">
                <button className="btn btn-primary" type="button" disabled={fetchingReg || !isFilterSelected || isFetchingExistingAdmsnPageInfo} onClick={fetchRegistrationsByFilter}>
                  Search
                </button>
                <h6 className="ml-3 mr-3">Or instead...</h6>
                <button className="btn btn-outline-primary" type="button" onClick={fetchAllRegistrations} disabled={fetchingReg || isFetchingExistingAdmsnPageInfo}>
                  Get Full List
                </button>
              </div>
              <div className="d-flex mt-3">
                <div style={{ fontSize: "12px", textTransform: 'capitalize' }}>Selected Filters: [{`${selectedFilters}`}]</div>
                <div className="ml-3" style={{ fontSize: "12px", textTransform: 'capitalize' }}>Total Results: {`${filteredReg.length}`}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderBulkAction = () => {
    const isBulkActionRequired = filters['admissionStatus'] !== 'none' && filters['admissionStatus'] !== "paidnverified";

    if (!isBulkActionRequired || !fetchRegSuccess) {
      return null;
    }

    return (
      <div className="card p-3 d-flex flex-row align-items-center">
        Bulk Action: 
        <button className="btn btn-outline-danger ml-3" onClick={() => bulkAction({blockAll: true})}>Block All</button>
        <button className="btn btn-outline-success ml-3" onClick={() => bulkAction({unBlockAll: true})}>Unblock All</button>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Control student login</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Restrict user from logging in to website
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title mr-1">Block/UnBlock student account login access</h3>
          {fetchingReg === true && <LoaderSpinner />}
        </div>

        <div className="card-body" style={{ marginTop: 0, paddingTop: 0 }}>
          {/* <p>TODO on this panel:</p>
            <p>Trigger message/mail when activity updated (OPTIONAL).</p> */}
          {renderFilterSection()}
          <hr />
          {renderBulkAction()}
          {renderCompleteList()}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}
